(function() { window.GUID_2a63e17b_f4f3_4eb1_8c4c_520704009b6b = { getGuid: function() { return "2a63e17b-f4f3-4eb1-8c4c-520704009b6b"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let LayoutType;
        (function (LayoutType) {
            LayoutType[LayoutType["Cards"] = 0] = "Cards";
            LayoutType[LayoutType["Grid"] = 1] = "Grid";
        })(LayoutType = Enumeration.LayoutType || (Enumeration.LayoutType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=LayoutType.pre.js.map
